<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <b-row class="header-container-logo">
                <b-col cols="6" class="header-image">
                    <b-img @click="onClickLogo" class="header-image-content" src="/logo.png" block alt="Sinar Mutiara Logo"></b-img>
                </b-col>
                <b-col cols="6" class="header-cart">
                    <b-button variant="danger" class="ml-2 header-cart-button" title="Logout"
                        :disabled="isSubmitting" @click="onClickLogout">
                        <i class="fa fa-fw fa-sign-out"></i>
                    </b-button>
                </b-col>
            </b-row>
            <b-row class="header-container-title">
                <b-col cols="12" class="header-title">
                    <b-button class="mr-2 header-button-back" @click="$router.push({ path: '/katalog' })">
                        <i class="fa fa-fw fa-chevron-left header-button-back-content" />
                    </b-button>
                    <h4 class="mb-0 header-title-text">
                        <i class="fa fa-fw fa-cubes mr-2" />{{ currType.kind }} {{ currType.brand }} {{ currType.type }}
                    </h4>
                </b-col>
            </b-row>
            <hr />
            <!-- <b-row>
                <b-col cols="3" sm="2" lg="1">
                    <b-input-group>
                        <b-input-group-prepend>
                            <b-button variant="dark" @click="$bvModal.show('m-filter')">
                                <i class="fa fa-search mr-2" />Filter...
                            </b-button>
                        </b-input-group-prepend>
                        <b-form-input v-model="filter.noFaktur" maxlength="50" placeholder="Cari Kode Barang..." @keydown.enter="getItems()" />
                        <b-input-group-append>
                            <b-button variant="primary" @click="getItems()">Cari Faktur</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-col>
                <b-col cols="5" sm="5" lg="5">
                    <b-button variant="secondary" @click="$router.push({ path: '/katalog' })">
                        Kembali
                    </b-button>
                </b-col>
            </b-row> -->
            <b-table bordered hover show-empty no-local-sorting
                :busy="isBusy"
                :items="items"
                :fields="fields"
                @sort-changed="onSortChanged"
                responsive class="my-3"
            >
                <template v-slot:empty>
                    Tidak ada data inventory.
                </template>
                <template v-slot:cell(price)="row">
                    <!-- <div class="small" style="text-decoration: line-through" v-if="row.item.base_price != row.item.final_price"> -->
<!--                     <div class="small" style="text-decoration: line-through" v-if="row.item.base_price != row.item.final_price_after_adj">
                        Rp. {{ $helper.formatThousand(row.item.base_price) }}
                    </div> -->
                    <!-- Rp. {{ $helper.formatThousand(row.item.final_price) }} -->
                    <!-- Rp. {{ $helper.formatThousand(row.item.final_price_after_adj) }} -->
                    Rp. {{ $helper.formatThousand(row.item.price) }}
                    <!-- <div class="small">
                        Harga Dasar: Rp. {{ $helper.formatThousand(row.item.base_price) }}<br />
                        Kloter {{ $helper.parseDate(row.item.created) }}
                    </div> -->
                </template>
                <template v-slot:cell(appraisal)="row">
                    <strong>{{ row.item.grade }}</strong>
                </template>
                <template v-slot:cell(detail)="row">
                    {{ row.item.is_batangan == true ? "Batangan" : "Lengkap" }} - {{ row.item.spec }}<br />
                    <div class="small">
                        <span v-if="row.item.item_year != null">Tahun {{ row.item.item_year }}</span>
                    </div>
                </template>
                <template v-slot:cell(item)="row">
                    <!-- <strong>{{ row.item.list.length }}</strong> -->
                    <span v-if="row.item.list.length <= 50"><strong>{{ row.item.list.length }}</strong> unit</span>
                    <span v-else>Lebih dari <strong>50</strong> unit</span>
                </template>
                <template v-slot:cell(kerusakan)="row">
                        <span v-if="row.item.list[0].adjustments.length < 1">-</span><span v-else><span v-for="(adjustment, index) in row.item.list[0].adjustments" :key="'adj-' + index">{{ adjustment }}<span v-if="index < row.item.list[0].adjustments.length - 1">, </span></span></span>
                </template>
                <template v-slot:cell(action)="row">
                    <!-- <b-button size="sm" class="ml-2" variant="dark" v-b-tooltip.hover.top title="Daftar Gambar" :disabled="isSubmitting" @click="prepareImage(row.item)">
                        <i class="fa fa-fw fa-picture-o" />
                    </b-button> -->
                    <b-button size="sm" variant="dark" v-b-tooltip.hover.top title="List Item" @click="listItem(row.item.list)">
                        <i class="fa fa-fw fa-list-alt" />
                    </b-button>
                </template>
            </b-table>
            <PageSizer :totalRows="totalRows" :page="currentPage" :options="options" @limit-change="onLimitChange" @page-change="onPageChange" />
        </b-card>
        <b-modal id="m-filter" title="Filter Pencarian" size="lg" no-close-on-backdrop no-close-on-esc hide-footer>
            <!-- <strong>DATA BARANG</strong>
            <b-row>
                <b-col md="4">
                    <b-form-group label="Tahun / Generasi Barang">
                        <b-form-input v-model="filter.itemYear" maxlength="4" />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="No. Faktur PGI">
                        <b-form-input v-model="filter.noFaktur" maxlength="50" />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="IMEI / SN">
                        <b-form-input v-model="filter.imeiSn" maxlength="100" />
                    </b-form-group>
                </b-col>
            </b-row>
            <hr /> -->
            <strong>DATA BARANG</strong>
            <b-row class="mt-1">
                <b-col md="4">
                    <b-form-group label="Harga Minimum">
                        <b-form-input
                            v-model="filter.minPrice"
                            maxlength="50"
                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                            @input="sanitizeMinPrice"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="Harga Maksimum">
                        <b-form-input
                            v-model="filter.maxPrice"
                            maxlength="50"
                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                            @input="sanitizeMaxPrice"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <strong>PENILAIAN BARANG</strong>
            <b-row class="mt-1">
                <b-col md="4">
                    <b-form-group label="Grade">
                        <multiselect :multiple="true" :close-on-select="false"
                            v-model="filter.grade"
                            label="name"
                            track-by="id"
                            :internal-search="true"
                            deselect-label=""
                            select-label=""
                            :options="optGrade"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="Kelengkapan">
                        <b-form-select v-model="filter.isBatangan" :options="optIsBatangan" />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="Spek">
                        <multiselect v-model="filter.spec"
                            label="name"
                            track-by="id"
                            :internal-search="true"
                            deselect-label=""
                            select-label=""
                            :options="optSpec"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <!-- <hr />
            <strong>KLOTER PENGIRIMAN</strong>
            <b-row class="mt-1">
                <b-col md="4">
                    <b-form-group label="Dari">
                        <b-form-input type="date" v-model="filter.from" />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="Sampai">
                        <b-form-input type="date" v-model="filter.to" />
                    </b-form-group>
                </b-col>
            </b-row> -->
            <div class="mt-4 text-right">
                <b-button variant="danger" @click="resetFilter">
                    Reset Filter
                </b-button>
                <b-button variant="primary" class="ml-3" @click="getItems()">
                    Cari
                </b-button>
            </div>
        </b-modal>
        <!-- <b-modal id="m-image" title="Galeri Gambar" @close="onCloseModalImage" size="lg" no-close-on-backdrop no-close-on-esc hide-footer>
            <b-row>
                <b-col cols="12">
                    <div class="media-container">
                        <b-img-lazy v-if="mediaPreview.media == 'image'" class="media-preview" :src="mediaPreview.status == 'upload' ? mediaPreview.url : $BASE_FILE_PATH + mediaPreview.url" blank-src="image-loading.gif" block alt="Image Preview"></b-img-lazy>
                        <video v-else-if="mediaPreview.media == 'video'" class="media-preview" controls :key="mediaPreview.url">
                            <source v-if="mediaPreview.type == 'video/webm'" :src="mediaPreview.status == 'upload' ? mediaPreview.url : $BASE_FILE_PATH + mediaPreview.url" :type="mediaPreview.type">
                            <source v-else-if="mediaPreview.type == 'video/ogg'" :src="mediaPreview.status == 'upload' ? mediaPreview.url : $BASE_FILE_PATH + mediaPreview.url" :type="mediaPreview.type">
                            <source v-else-if="mediaPreview.type == 'video/mp4'" :src="mediaPreview.status == 'upload' ? mediaPreview.url : $BASE_FILE_PATH + mediaPreview.url" :type="mediaPreview.type">
                            <source v-else-if="mediaPreview.type == 'video/3gpp'" :src="mediaPreview.status == 'upload' ? mediaPreview.url : $BASE_FILE_PATH + mediaPreview.url" :type="mediaPreview.type"> -->
                            <!-- <source v-else :src="mediaPreview.status == 'upload' ? mediaPreview.url : $BASE_FILE_PATH + mediaPreview.url" :type="mediaPreview.type"> -->
                            <!-- Your browser does not support the video tag.
                        </video>
                        <b-img-lazy v-else class="media-preview" src="/img/img-preview.png" block alt="No Image"></b-img-lazy>
                    </div>
                    <div class="media-scroll">
                        <div class="media-scroll-content" v-for="(media, index) in filterMediaList" :key="'ms-' + index" @click="onClickImage(media.url)">
                            <b-img-lazy class="media-scroll-preview" :class="{ active: media.isActive }" :src="media.media == 'video' ? '/img/video-thumbnail.png' : media.status == 'upload' ? media.url : $BASE_FILE_PATH + media.url" blank-src="/img/image-loading.gif" block :alt="media.altText"></b-img-lazy> -->
                            <!-- <b-img-lazy class="media-scroll-preview" :class="{ active: media.isActive }" src="https://sample-videos.com/img/Sample-png-image-5mb.png" blank-src="/img/image-loading.gif" block :alt="media.altText"></b-img-lazy> -->
                        <!-- </div>
                    </div>
                </b-col>
            </b-row>
            <div class="mt-4 text-right">
                <b-button variant="secondary" class="mr-2" :disabled="isSubmitting" @click="$bvModal.hide('m-image')">
                    Tutup
                </b-button>
            </div>
        </b-modal> -->
        <b-modal id="m-image" title="Galeri Gambar" @close="onCloseModalImage" size="xl" no-close-on-backdrop no-close-on-esc hide-footer>
            <b-row>
                <b-col cols="12" lg="5" order="2" order-lg="1" class="media-scroll-container">
                    <div v-for="(adj, index) in adjustmentList" :key="'adj-' + index">
                        <h6 class="media-scroll-header">{{ adj.category_name }} - {{ adj.adjustment_name }}</h6>
                        <div class="media-scroll">
                            <div class="media-scroll-content" v-for="(media, index) in adj.mediaList" :key="'ms-' + index" @click="onClickImage(media.url)">
                                <b-img-lazy class="media-scroll-preview" :class="{ active: media.isActive }" :src="media.media == 'video' ? '/img/video-thumbnail.png' : media.status == 'upload' ? media.url : media.url" blank-src="/img/image-loading.gif" block :alt="media.altText"></b-img-lazy>
                                <!-- <b-img-lazy class="media-scroll-preview" :class="{ active: media.isActive }" src="https://sample-videos.com/img/Sample-png-image-5mb.png" blank-src="/img/image-loading.gif" block :alt="media.altText"></b-img-lazy> -->
                            </div>
                        </div>
                    </div>
                </b-col>
                <b-col cols="12" lg="7" order="1" order-lg="2" class="border-responsive">
                    <div class="media-container">
                        <b-img-lazy v-if="mediaPreview.media == 'image'" class="media-preview" :src="mediaPreview.status == 'upload' ? mediaPreview.url : mediaPreview.url" blank-src="image-loading.gif" block alt="Image Preview"></b-img-lazy>
                        <video v-else-if="mediaPreview.media == 'video'" class="media-preview" controls :key="mediaPreview.url">
                            <source v-if="mediaPreview.type == 'video/webm'" :src="mediaPreview.status == 'upload' ? mediaPreview.url : mediaPreview.url" :type="mediaPreview.type">
                            <source v-else-if="mediaPreview.type == 'video/ogg'" :src="mediaPreview.status == 'upload' ? mediaPreview.url : mediaPreview.url" :type="mediaPreview.type">
                            <source v-else-if="mediaPreview.type == 'video/mp4'" :src="mediaPreview.status == 'upload' ? mediaPreview.url : mediaPreview.url" :type="mediaPreview.type">
                            <source v-else-if="mediaPreview.type == 'video/3gpp'" :src="mediaPreview.status == 'upload' ? mediaPreview.url : mediaPreview.url" :type="mediaPreview.type">
                            <!-- <source v-else :src="mediaPreview.status == 'upload' ? mediaPreview.url : $BASE_FILE_PATH + mediaPreview.url" :type="mediaPreview.type"> -->
                            Your browser does not support the video tag.
                        </video>
                        <b-img-lazy v-else class="media-preview" src="/img/img-preview.png" block alt="No Image"></b-img-lazy>
                    </div>
                </b-col>
            </b-row>
            <div class="mt-4 text-right">
                <b-button variant="secondary" class="mr-2" :disabled="isSubmitting" @click="$bvModal.hide('m-image')">
                    Tutup
                </b-button>
            </div>
        </b-modal>

        <b-modal id="m-item" title="List Item" size="lg" no-close-on-backdrop no-close-on-esc hide-footer>
            <b-row class="modal-small mb-2">
                <!-- <b-col cols="12">
                    <b-form-group
                        label="Cari Faktur"
                        label-for="filter-input"
                        label-cols-sm="3"
                        label-align-sm="left"
                        label-size="xl"
                    >
                        <b-input-group size="xl">
                            <b-form-input
                                id="filter-input"
                                v-model="filter2"
                                type="search"
                                placeholder="Cari Kode Barang..."
                            ></b-form-input>
                            <b-input-group-append>
                                <b-button :disabled="!filter2" @click="filter2=''">Clear</b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </b-col> -->
                <b-col cols="12" class="modal-table">
                    <!-- <b-row>
                        <b-col md="5">
                            <b-input-group>
                                <b-form-input v-model="filter2" maxlength="50" placeholder="Cari Kode Barang..." @keydown.enter="filter2" />
                                <b-input-group-append>
                                    <b-button variant="primary" @click="filter2">Cari Faktur</b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                    </b-row> -->
                    <b-table bordered hover show-empty
                        id="my-table"
                        :items="itemList"
                        :fields="fieldlistItem"
                        :per-page="perPage2"
                        :current-page="currentPage2"
                        :filter="filter2"
                        @filtered="currentPage2=1"
                        :sort-by.sync="sortBy2"
                        :sort-desc.sync="sortDesc2"
                        @sort-changed="onSortChanged2"
                        responsive class="my-3">

                        <template v-slot:cell(kode)="row">
                            <strong>{{ row.item.no_faktur_pgi }}</strong>
                        </template>
                        <template v-slot:cell(harga)="row">
                            Rp. {{ $helper.formatThousand(row.item.final_price_after_segment) }}
                        </template>
                        <template v-slot:cell(grade)="row">
                            <strong>{{ row.item.grade }}</strong>
                        </template>
                        <template v-slot:cell(detail)="row">
                            {{ row.item.is_batangan == true ? "Batangan" : "Lengkap" }} - {{ row.item.spec }}<br />
                            <div class="small">
                                <span v-if="row.item.item_year != null">Tahun {{ row.item.item_year }}</span>
                            </div>
                        </template>
                        <template v-slot:cell(kerusakan)="row">
                            <div v-if="row.item.adjustments.length > 0">
                                <span v-for="(adjustment, index) in row.item.adjustments" :key="'adj-' + index">{{ adjustment }}<span v-if="index < row.item.adjustments.length - 1">, </span></span>
                            </div>
                            <span v-else>-</span>
                        </template>

                        <template v-slot:cell(action)="row">
                            <b-button size="sm" variant="dark" v-b-tooltip.hover.top title="Daftar Gambar" :disabled="isSubmitting || row.item.adjustments.length <= 0" @click="prepareImage(row.item)">
                                <i class="fa fa-fw fa-picture-o" />
                            </b-button>
                        </template>
                    </b-table>
                </b-col>
            </b-row>

            <PageSizer :totalRows="rows" :page="currentPage2" :options="options" @limit-change="onLimitChange2" @page-change="onPageChange2" />

            <div class="mt-4 text-right">
                <b-button variant="secondary" class="mr-2" @click="$bvModal.hide('m-item')">
                    Tutup
                </b-button>
            </div>
        </b-modal>
        <b-modal id="m-cart" title="Keranjang" size="xl" no-close-on-backdrop no-close-on-esc hide-footer>
            <b-row class="modal-small mb-2">
                <b-col cols="12" class="modal-table">
                    <b-table bordered hover show-empty
                        :busy="isBusy"
                        :items="cartList"
                        :fields="fieldlistCart"
                        :per-page="perPage3"
                        :filter="filter3"
                        @filtered="currentPage3=1"
                        :sort-by.sync="sortBy3"
                        :sort-desc.sync="sortDesc3"
                        @sort-changed="onSortChanged3"
                        responsive class="my-3">

                        <template v-slot:cell(merk)="row">
                            <span>{{ row.item.brands }}</span>
                        </template>
                        <template v-slot:cell(jenis)="row">
                            <span>{{ row.item.types }}</span>
                        </template>
                        <template v-slot:cell(kode)="row">
                            <strong>{{ row.item.no_faktur_pgi }}{{ row.item.append_faktur > 9 ? row.item.append_faktur.toString().substr(1,1) : row.item.append_faktur }}</strong>
                        </template>
                        <template v-slot:cell(harga)="row">
                            Rp. {{ $helper.formatThousand(row.item.final_price_after_segment) }}
                        </template>
                        <template v-slot:cell(grade)="row">
                            <strong>{{ row.item.grade }}</strong>
                        </template>
                        <template v-slot:cell(detail)="row">
                            {{ row.item.is_batangan == true ? "Batangan" : "Lengkap" }} - {{ row.item.specs }}<br />
                            <div class="small">
                                <span v-if="row.item.item_year != null">Tahun {{ row.item.item_year }}</span>
                            </div>
                        </template>
                        <template v-slot:cell(kerusakan)="row">
                            <div v-if="row.item.kerusakan != null">
                                <span>{{row.item.kerusakan}}</span>
                            </div>
                            <span v-else>-</span>
                        </template>

                        <template v-slot:cell(action)="row">
                            <b-button size="sm" variant="danger" class="ml-2" v-b-tooltip.hover.top title="Hapus dari keranjang"
                                :disabled="isSubmitting" @click="removeItemFromCart(row.item)">
                                <i class="fa fa-fw fa-minus" />
                            </b-button>
                        </template>
                    </b-table>
                </b-col>
            </b-row>
            <PageSizer :totalRows="totalRows3" :page="currentPage3" :options="options" @limit-change="onLimitChange3" @page-change="onPageChange3" />

            <div class="mt-4 text-right">
                <b-button variant="primary" class="mr-2" :disabled="isSubmitting || cartList.length == 0" @click="calculateShoppingCart">
                    Kirim
                </b-button>
                <b-button variant="secondary" class="mr-2" @click="$bvModal.hide('m-cart')">
                    Tutup
                </b-button>
            </div>
        </b-modal>
        <b-modal id="m-calculate" title="Total Order" no-close-on-backdrop no-close-on-esc hide-footer>
            <div v-if="isSubmitting">
                Mengambil data, mohon menunggu...
            </div>
            <div v-else>
                Qty : {{ countShoppingCart }}<br />
                Harga : Rp. {{ totalShoppingCart }}
                <div class="mt-4 text-right">
                    <b-button variant="primary" class="mr-2" :disabled="isSubmitting" @click="sendShoppingCart">
                        Order
                    </b-button>
                    <b-button variant="secondary" class="mr-2" @click="$bvModal.hide('m-calculate')">
                        Cancel
                    </b-button>
                </div>
            </div>
        </b-modal>
        <b-modal id="m-requested" title="Request Order" no-close-on-backdrop no-close-on-esc hide-footer>
            <div v-if="isSubmitting">
                Mengambil data, mohon menunggu...
            </div>
            <div v-else>
                <div v-for="(admin, index) in adminDivisions" :key="'phone-' + index" style="text-align: center">
                    <b-button class="mt-2" v-if="admin.admin_phone != null" @click="sendMessageAdmin(admin.admin_phone)" style="background-color: #25D366; border-color: #25D366; color: #fff;">
                        <i class="fa fa-whatsapp mr-1"></i>Order
                    </b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import lodash from 'lodash'

export default {
    data() {
        return {
            perPage2: 10,
            currentPage2: 1,

            initStatus: 0,
            isBusy: true,
            isSubmitting: false,
            show: 10,

            activeId: 0,

            filter2: null,

            filter: {
                // itemYear: "",
                spec: null,
                // noFaktur: "",
                // imeiSn: "",
                grade: [],
                isBatangan: -1,
                // from: null,
                // to: null,
                minPrice: "",
                maxPrice: ""
            },

            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],

            fields: [
                { key: "price", label: "Harga Jual", sortable: true },
                { key: "appraisal", label: "Grade", sortable: true },
                { key: "detail", label: "Detail", sortable: true },
                { key: "item", label: "Jumlah", sortable: true },
                { key: "kerusakan", label: "Kerusakan", sortable: true },
                { key: "action", label: "Aksi" },
            ],

            fieldlistItem: [
                { key: "kode", label: "Kode Barang", sortable: true },
                { key: "harga", label: "Harga Jual", sortable: false },
                { key: "grade", label: "Grade", sortable: false },
                { key: "detail", label: "Detail", sortable: false },
                { key: "kerusakan", label: "Kerusakan", sortable: false },
                { key: "action", label: "Aksi" },
            ],

            itemList: [],
            items: [],
            activeItem: {},
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            sortBy: null,
            sortDesc: false,

            sortBy2: null,
            sortDesc2: false,

            optSpec: [],

            optGrade: [
                { id: "S", name: "S" },
                { id: "A", name: "A" },
                { id: "B", name: "B" },
                { id: "C", name: "C" },
                { id: "X", name: "X" },
            ],
            optIsBatangan: [
                { value: -1, text: "Semua" },
                { value: 1, text: "Batangan" },
                { value: 0, text: "Lengkap" }
            ],

            mediaPreview: {},

            mediaList: [],

            isImageChanged: false,

            currType: {},

            adjustmentList: [],

            cartInventoryIds: [],

            fieldlistCart: [
                { key: "merk", label: "Merk Barang", sortable: false },
                { key: "jenis", label: "Jenis Barang", sortable: false },
                { key: "kode", label: "Kode Barang", sortable: false },
                { key: "harga", label: "Harga Jual", sortable: false },
                { key: "grade", label: "Grade", sortable: false },
                { key: "detail", label: "Detail", sortable: false },
                { key: "kerusakan", label: "Kerusakan", sortable: false },
                { key: "action", label: "Aksi" },
            ],
            cartList: [],
            perPage3: 10,
            currentPage3: 1,
            sortBy3: null,
            sortDesc3: false,
            filter3: null,
            totalRows3: 0,

            countShoppingCart: 0,
            totalShoppingCart: 0,

            noRequest: "",
            adminDivisions: [],

            currOffice: null,
            tokopediaUrl: ""

        }
    },

    methods: {

        init() {

            this.initStatus = 0
            let getItems = this.getItems()
            let getInventoryIds = this.getInventoryIdsByType()

            let getSpecs = this.$axios.get("catalog/spec").then(res => {
                this.optSpec = res.data.data
            })

            let getCurrentType = this.$axios.get("catalog/detail?typeId=" + this.$route.params.id).then(res => {
                this.currType = res.data.data
            })

            let getMarketplaceUrl = this.$axios.get("catalog/marketplace-url").then(res => {
                this.tokopediaUrl = res.data.data.tokopedia_url
            })

            Promise.all([getItems, getSpecs, getCurrentType, getInventoryIds, getMarketplaceUrl]).then(_ => {
                this.initStatus = 1
            })
            .catch(_ => this.initStatus = -1)

        },

        getItems(page = 1) {

            this.$bvModal.hide("m-filter")
            this.isBusy = true
            this.items = []

            if(isNaN(page)) {
                this.currentPage = 1
            }
            else {
                this.currentPage = page
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(this.currentPage, this.perPage)
            param += this.processFilter()

            if(!this.$helper.isBlank(this.sortBy)) {
                param += "&sortBy=" + this.sortBy
                param += "&sortDesc=" + this.sortDesc
            }

            param += "&typeId=" + this.$route.params.id

            if(!this.$helper.isBlank(this.currOffice)){
                param += "&officeId=" + this.currOffice.id
            }

            sessionStorage.setItem("katalogDetailPage", this.currentPage)

            return this.$axios.get("catalog/detail/list" + param).then(res => {
                this.items = res.data.data.items
                this.totalRows = res.data.data.total
                sessionStorage.setItem("listKatalogDetailFilter" + this.$route.params.id, JSON.stringify(this.filter))
                // for(let i = 0; i < this.items.length; i++){
                //     for(let j = 0; j < this.items[i].list.length; j++){
                //         let addDigit = (parseInt(this.items[i].list[j].no_faktur_pgi.slice(-1)) + 2) % 10
                //         this.items[i].list[j].no_faktur_pgi = this.items[i].list[j].no_faktur_pgi + String(addDigit)
                //     }
                // }
                // console.log(this.items)
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isBusy = false
            })

        },

        listItem(item) {
            this.itemList = item
            this.$bvModal.show("m-item")
        },

        prepareImage(item) {
            this.activeItem = item
            this.activeId = item.id
            this.mediaPreview = {}
            this.mediaList = []
            this.adjustmentList = []
            this.isSubmitting = true
            let param = "?id=" + item.id
            this.$axios.get("catalog/detail/item/photos-adj" + param).then(res => {
                for(let i = 0; i < res.data.data.length; i++){
                    res.data.data[i].mediaList = []
                    for(let j = 0; j < res.data.data[i].photos.length; j++){
                        let fileMedia = ''
                        let fileAltText = ''
                        if(res.data.data[i].photos[j].type == 'image/jpeg' || res.data.data[i].photos[j].type == 'image/png') {
                            fileMedia = 'image'
                            fileAltText = 'Upload Image Preview'
                        }
                        else if(res.data.data[i].photos[j].type == 'video/mp4' || res.data.data[i].photos[j].type == 'video/webm' || res.data.data[i].photos[j].type == 'video/ogg' || res.data.data[i].photos[j].type == 'video/3gpp'){
                            fileMedia = 'video'
                            fileAltText = 'Upload Video Preview'
                        }
                        else {
                            continue
                        }
                        let filenameSplit = res.data.data[i].photos[j].path.split('/')
                        filenameSplit = filenameSplit[filenameSplit.length-1].split('.')
                        let fileExtension = filenameSplit.pop()
                        let filename = filenameSplit.join()
                        res.data.data[i].mediaList.push({
                            id: res.data.data[i].photos[j].id,
                            media: fileMedia,
                            type: res.data.data[i].photos[j].type,
                            filename: filename,
                            extension: fileExtension,
                            url: res.data.data[i].photos[j].path,
                            altText: fileAltText,
                            status: 'get',
                            isActive: false,
                            file: null
                        })
                    }
                }
                this.adjustmentList = res.data.data
                this.isImageChanged = false
                this.$bvModal.show("m-image")
                // console.log(this.adjustmentList)
            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)
        },

        onClickImage(url) {
            for(let i = 0; i < this.adjustmentList.length; i++){
                for(let j = 0; j < this.adjustmentList[i].mediaList.length; j++){
                    this.adjustmentList[i].mediaList[j].isActive = false
                    if(this.adjustmentList[i].mediaList[j].url == url){
                        this.adjustmentList[i].mediaList[j].isActive = true
                        this.mediaPreview = lodash.cloneDeep(this.adjustmentList[i].mediaList[j])
                    }
                }
            }
        },

        onCloseModalImage(e){
            if(this.isImageChanged){
                let isConfirmed = confirm("Apakah anda yakin ingin menutup menu Gambar Kerusakan? Perubahan yang belum disimpan akan hilang.")
                if(!isConfirmed) e.preventDefault()
            }
        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems(this.currentPage)
        },

        onPageChange(newPage) {
            this.currentPage = newPage
            sessionStorage.setItem("katalogDetailPage", this.currentPage)
            this.getItems(this.currentPage)
        },

        onLimitChange2(newPerPage) {
            this.perPage2 = newPerPage
        },

        onPageChange2(newPage) {
            this.currentPage2 = newPage
        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDesc = ctx.sortDesc
            this.getItems()
        },

        onSortChanged2(ctx) {
            this.sortBy2 = ctx.sortBy
            this.sortDesc2 = ctx.sortDesc

            if(this.sortDesc2){
            this.itemList.sort((a, b) => (a.no_faktur_pgi > b.no_faktur_pgi) ? 1 : -1);
            }else{
            this.itemList.sort((a, b) => (a.no_faktur_pgi > b.no_faktur_pgi) ? -1 : 1);
            }
            // console.log(this.sortDesc2)
        },

        resetFilter() {

            this.filter = {
                // itemYear: "",
                spec: null,
                // noFaktur: "",
                // imeiSn: "",
                grade: [],
                isBatangan: -1,
                // from: null,
                // to: null,
                minPrice: "",
                maxPrice: ""
            }

            this.getItems()

        },

        processFilter() {

            let param = ""

            // if(!this.$helper.isBlank(this.filter.itemYear) && !isNaN(this.filter.itemYear)) {
            //     param += "&filterItemYear=" + Number(this.filter.itemYear)
            // }

            // if(!this.$helper.isBlank(this.filter.noFaktur)) {
            //     param += "&filterNoFaktur=" + this.filter.noFaktur
            // }

            // if(!this.$helper.isBlank(this.filter.imeiSn)) {
            //     param += "&filterImeiSn=" + this.filter.imeiSn
            // }

            if(this.filter.grade.length != 0) {
                param += "&filterGrade=" + this.filter.grade.map(it => it.id).join()
            }

            if(this.filter.isBatangan != -1) {
                param += "&filterIsBatangan=" + this.filter.isBatangan
            }

            if(this.filter.spec != null) {
                param += "&filterSpec=" + this.filter.spec.id
            }

            // if(this.filter.from != null) {
            //     param += "&filterFrom=" + this.filter.from
            // }

            // if(this.filter.to != null) {
            //     param += "&filterTo=" + this.filter.to
            // }

            let minPrice = this.$helper.toNumber(this.filter.minPrice)

            if(!this.$helper.isBlank(minPrice) && minPrice != 0) {
                param += "&filterMinPrice=" + minPrice
            }

            let maxPrice = this.$helper.toNumber(this.filter.maxPrice)

            if(!this.$helper.isBlank(maxPrice) && maxPrice != 0) {
                param += "&filterMaxPrice=" + maxPrice
            }

            return param

        },

        sanitizeMinPrice() {
            let cleaned = String(this.filter.minPrice).replace(/\./g, "")
            let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            this.filter.minPrice = res
        },

        sanitizeMaxPrice() {
            let cleaned = String(this.filter.maxPrice).replace(/\./g, "")
            let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            this.filter.maxPrice = res
        },

        addItemToCart(item){
            this.isSubmitting = true

            let payload = new FormData()
            payload.append("customerId", localStorage.getItem('customerId-katalog'))
            payload.append("inventoryId", item.id)
            payload.append("catalogDivisionId", JSON.parse(sessionStorage.getItem("listKatalogDivision")).id)

            if(!this.$helper.isBlank(this.currOffice)){
                payload.append("officeId", this.currOffice.id)
            }

            this.$axios.post(`/catalog/add-item-shopping-cart`, payload).then(response => {

                this.$helper.toastSuccess(this, "Barang telah ditambahkan ke keranjang!")
                this.cartInventoryIds.push(item.id)
            })
            .catch(error => {
                this.$helper.toastError(this, error.response.data.error)
            }).finally(() => {
                this.isSubmitting = false
            })
        },

        getInventoryIdsByType(){
            let param  = "?customerId="+localStorage.getItem('customerId-katalog')+"&typeId="+this.$route.params.id
            if(!this.$helper.isBlank(this.currOffice)){
                param += "&officeId=" + this.currOffice.id
            }
            return this.$axios.get(`/catalog/get-cart-inventory-id-by-type`+param).then(response => {
                this.cartInventoryIds = response.data.data
            }).catch(error => {
                this.$helper.toastError(this, error.response.data.error)
            })
        },

        filterInventory(id){
            return this.cartInventoryIds.filter(n=>n===id).length===0?false:true
        },

        showCart(modal){
            this.cartList = []
            this.isBusy = true
            let param = this.$helper.getBasePagedQuery(this.currentPage3, this.perPage3)
            param += "&customerId="+localStorage.getItem('customerId-katalog')

            if(!this.$helper.isBlank(this.currOffice)){
                param += "&officeId=" + this.currOffice.id
            }

            sessionStorage.setItem("shoppingCartPage", this.currentPage3)

            return this.$axios.get(`/catalog/get-shopping-cart`+param).then(response=> {
                this.cartList = response.data.data.items
                this.totalRows3 = response.data.data.total
                if(modal){
                    this.$bvModal.show("m-cart")
                }
            })
            .catch(error => {
                this.$helper.toastError(this, error.response.data.error)
            }).finally(() => {
                this.isBusy = false
            })
        },
        onSortChanged3(ctx) {
            this.sortBy3 = ctx.sortBy
            this.sortDesc3 = ctx.sortDesc
            this.showCart(false)
        },
        onLimitChange3(newPerPage) {
            this.perPage3 = newPerPage
        },

        onPageChange3(newPage) {
            this.currentPage3 = newPage
            sessionStorage.setItem("shoppingCartPage", this.currentPage3)
            this.showCart(false)
        },
        removeItemFromCart(item){
            this.isSubmitting = true

            let payload = new FormData()
            payload.append("customerId", localStorage.getItem('customerId-katalog'))
            payload.append("inventoryId", item.id)

            if(!this.$helper.isBlank(this.currOffice)){
                payload.append("officeId", this.currOffice.id)
            }

            this.$axios.post(`/catalog/remove-item-shopping-cart`, payload).then(response => {

                this.cartInventoryIds.splice(this.cartInventoryIds.indexOf(item.id), 1)
                this.$helper.toastSuccess(this, "Barang telah dihapus dari keranjang!")
                this.showCart(false)

            })
            .catch(error => {
                this.$helper.toastError(this, error.response.data.error)
            }).finally(() => {
                this.isSubmitting = false
            })
        },
        calculateShoppingCart(){
            this.isSubmitting = true
            this.isBusy = true

            this.$bvModal.show("m-calculate")

            let payload = new FormData()
            payload.append("customerId", localStorage.getItem('customerId-katalog'))

            if(!this.$helper.isBlank(this.currOffice)){
                payload.append("officeId", this.currOffice.id)
            }

            this.$axios.post(`/catalog/calculate-shopping-cart`, payload).then(response => {
                this.countShoppingCart = response.data.data.count
                this.totalShoppingCart = this.$helper.formatThousand(parseInt(response.data.data.total))
            })
            .catch(error => {
                this.$helper.toastError(this, error.response.data.error)
            }).finally(() => {
                this.isSubmitting = false
                this.isBusy = false
            })
        },
        sendShoppingCart(){
            this.isSubmitting = true
            this.isBusy = true

            let payload = new FormData()
            payload.append("customerId", localStorage.getItem('customerId-katalog'))

            if(!this.$helper.isBlank(this.currOffice)){
                payload.append("officeId", this.currOffice.id)
            }

            this.$axios.post(`/catalog/add-shopping-cart-request`, payload).then(response => {
                this.$bvModal.hide("m-cart")
                this.$bvModal.hide("m-calculate")

                this.cartInventoryIds = []

                this.noRequest = response.data.data.no_request
                this.adminDivisions = response.data.data.divisions
                this.$helper.toastSuccess(this, "Barang telah di request ke SM!")
                this.$bvModal.show("m-requested")
            })
            .catch(error => {
                this.$helper.toastError(this, error.response.data.error)
            }).finally(() => {
                this.isSubmitting = false
                this.isBusy = false
            })
        },
        sendMessageAdmin(phone){
            window.open('https://wa.me/'+phone+'/?text=Nomor Orderan : '+this.noRequest+' tolong diproses')
        },
        onClickLogo(){
            sessionStorage.removeItem("listKatalogDivision")
            sessionStorage.removeItem("listKatalogOffice")
            this.$router.push({ path: "/katalog" })
        },
        onClickLogout(){
            let confirmed = confirm("Apakah anda yakin ingin log out? Anda akan kembali ke menu utama.")
            if(confirmed) {
                this.$axios.defaults.headers.common['Authorization'] = ""
                localStorage.clear()
                this.$router.push({ path: "/katalog" })
            }
        }

    },
    computed: {
        filterMediaList(){
            return this.mediaList.filter(item => item.status != 'delete')
        },
        rows() {
            return this.itemList.length
        }

    },
    created() {
        if(!this.$helper.isBlank(sessionStorage.getItem("listKatalogOffice"))){
            this.currOffice = JSON.parse(sessionStorage.getItem("listKatalogOffice"))
        }
        if(!this.$helper.isBlank(sessionStorage.getItem("listKatalogDetailFilter" + this.$route.params.id))){
            this.filter = JSON.parse(sessionStorage.getItem("listKatalogDetailFilter" + this.$route.params.id))
        }
        if(!this.$helper.isBlank(sessionStorage.getItem("katalogDetailPage"))){
            this.currentPage = parseInt(sessionStorage.getItem("katalogDetailPage"))
        }
        if(!this.$helper.isBlank(sessionStorage.getItem("shoppingCartPage"))){
            this.currentPage3 = parseInt(sessionStorage.getItem("shoppingCartPage"))
        }
        this.filter.minPrice = this.$route.query.minPrice.toString()
        this.filter.maxPrice = this.$route.query.maxPrice.toString()
        this.filter.isBatangan = this.$route.query.isBatangan
        if(this.$route.query.spec == "") this.filter.spec = null
        else{
            this.$route.query.spec = this.$route.query.spec.split(",")
            this.filter.spec = {
                id: this.$route.query.spec[0],
                name: this.$route.query.spec[1]
            }
        }
        if(this.$route.query.grade == "") this.filter.grade = ""
        else{
            this.$route.query.grade = this.$route.query.grade.split(",")
            this.filter.grade = []
            for(let i = 0; i < this.$route.query.grade.length; i++){
                this.filter.grade.push({
                    id: this.$route.query.grade[i],
                    name: this.$route.query.grade[i]
                })
            }
        }
        this.init()
    }
}
</script>

<style scoped>
    hr {
        margin-top:15px;
    }
    .modal {
        padding: 0px;
    }
    .modal-small {
        padding: 5px;
    }
    .modal-table {
        padding: 0px;
    }
    .header-container-logo {
        height: 70px;
        margin-bottom: 10px;
    }
    .header-container-title {
        height: 40px;
    }
    .header-title {
        display: flex;
        align-items: center;
        height: 40px;
        overflow-y: hidden;
    }
    .header-button-back {
        float: left;
        padding: 0px;
        height: 30px;
        width: 30px;
        background-color: white;
        border: 0px;
    }
    .header-button-back-content {
        margin-top: 4px;
        font-size: 1.45rem;
    }
    .header-title-text {
        font-size: 1rem;
        font-weight: 700;
    }
    .header-image {
        text-align: center;
        height: 70px;
    }
    .header-image-content {
         height:100%;
         cursor:pointer;
    }
    .header-cart {
        text-align: right;
        display: flex;
        align-items: center;
        justify-content:flex-end;
    }
    .header-cart-button {
        font-size: 0.9rem;
    }
    .header-cart-text {
        display: none;
    }
    /* .media-container {
        height: 0;
        padding-top: 56.25%;
        position: relative;
    }
    .media-preview {
        max-height: 100%;
        max-width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        border: 1px solid #dee2e6;
        border-radius: .25rem;
        object-fit: cover;
        background-color: #dee2e6;
        left: 50%;
        transform: translateX(-50%);
    }
    :not(:root):-webkit-full-screen {
        object-fit: contain !important;
    }
    .media-scroll {
        margin-top: 10px;
        height: 70px;
        width: 100%;
        overflow-x: scroll;
        overflow-y: hidden;
        background-color: #dee2e6;
        white-space: nowrap;
    }
    .media-scroll-content {
        display: inline-block !important;
        height: 100%;
        width: 20%;
    }
    .media-scroll-preview.active {
        border: 5px solid #65c2e4;
    }
    .media-scroll-preview:hover {
        opacity: 0.5;
    }
    .media-scroll-preview {
        height: 100%;
        width: 100%;
        border: 5px solid #dee2e6;
        border-radius: .25rem;
        object-fit: cover;
        background-color: #dee2e6;
        cursor: pointer;
    }
    .border-responsive {
        margin-top: 10px;
        border-top: 1px solid #c8ced3;
    }
    .media-disclaimer {
        text-align: justify;
        text-justify: inter-word;
    }
    @media only screen and (min-width: 576px) {
        .media-scroll {
            height: 100px;
        }
    }
    @media only screen and (min-width: 992px) {
        .border-responsive {
            margin-top: 0px;
            border-top: none;
            border-left: 1px solid #c8ced3;
        }
    }
    @media only screen and (min-width: 1200px) {
        .media-scroll {
            height: 150px;
        }
    } */
    .media-container {
        height: 0;
        padding-top: 75%;
        position: relative;
    }
    .media-preview {
        max-height: 100%;
        max-width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        border: 1px solid #dee2e6;
        border-radius: .25rem;
        object-fit: cover;
        background-color: #dee2e6;
        left: 50%;
        transform: translateX(-50%);
    }
    :not(:root):-webkit-full-screen {
        object-fit: contain !important;
    }
    .media-scroll-container {
        max-height: 250px;
        overflow-y: scroll;
    }
    .media-scroll-header {
        font-size: 10px;
        margin-top: 10px;
        margin-bottom: 3px;
        margin-left: 2px;
    }
    .media-scroll {
        height: 70px;
        width: 100%;
        overflow-x: scroll;
        overflow-y: hidden;
        background-color: #dee2e6;
        white-space: nowrap;
    }
    .media-scroll-content {
        display: inline-block !important;
        height: 100%;
        width: 20%;
    }
    .media-scroll-preview.active {
        border: 5px solid #65c2e4;
    }
    .media-scroll-preview:hover {
        opacity: 0.5;
    }
    .media-scroll-preview {
        height: 100%;
        width: 100%;
        border: 5px solid #dee2e6;
        border-radius: .25rem;
        object-fit: cover;
        background-color: #dee2e6;
        cursor: pointer;
    }
    .border-responsive {
        padding-bottom: 10px;
        border-bottom: 1px solid #c8ced3;
    }
    .media-disclaimer {
        text-align: justify;
        text-justify: inter-word;
    }
    @media only screen and (min-width: 576px) {
        hr {
            margin-top:4px;
        }
        .header-cart-text {
            display: inline;
        }
        .media-scroll {
            height: 100px;
        }
        .media-scroll-header {
            font-size: 12px;
        }
    }
    @media only screen and (min-width: 992px) {
        .media-scroll-container {
            max-height: 473px;
        }
        .border-responsive {
            padding-bottom: 0px;
            border-bottom: none;
            border-left: 1px solid #c8ced3;
        }
        .media-scroll-content {
            width: 25%;
        }
    }
    @media only screen and (min-width: 1200px) {
        .media-scroll {
            height: 130px;
        }
        .media-scroll-header {
            font-size: 14px;
        }
    }

    .notification-banner {
        margin-bottom: 10px;
        padding: 10px 20px;
        width: 100%;
        border: 1px solid #FFD93D;
        background-color: #FDEB9F;
        text-align: center;
        font-weight: 600;
        color: #856404;
        font-size: 14px;
    }

</style>
